import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import { isEmptyPage } from '@/components/is-empty-file/isEmptyPage'
import { getCurrentPublicRuntimeConfig } from 'src/utils/helpers/helpers'

export type LocaleSlug = {
  [locale: string]: string
}

interface HrefLangLinksProps {
  hrefLangs: LocaleSlug
  brand?: Brand
}

export const renameLocale = {
  en: 'x-default',
  'nl-NL': 'nl',
  'de-DE': 'de',
}

export const HrefLangLinks = ({
  hrefLangs,
  brand = 'novasol',
}: HrefLangLinksProps): JSX.Element[] => {
  if (!hrefLangs) return

  if (hrefLangs['de-DE'] && hrefLangs['de']) {
    delete hrefLangs['de']
  }

  return (
    hrefLangs &&
    Object.entries(hrefLangs)?.map(([locale, link]) => {
      const localeBaseUrl =
        getCurrentPublicRuntimeConfig()?.[brand]?.localeBaseUrlMap?.[locale]

      return !isEmptyPage(link) && localeBaseUrl ? (
        <link
          key={locale}
          rel="alternate"
          data-testid="hreflang-link"
          hrefLang={renameLocale[locale] || locale?.toLowerCase()}
          href={`${localeBaseUrl}${link === '/' ? '' : `/${link}`}`}
        />
      ) : null
    })
  )
}
